<template>
  <CalicoOnboarding
    :loading="loading"
    :footer="false"
    :error="errorMessage"
  >
    <section class="payment">
      <div
        v-if="errorMessage"
        class="error body--small"
      >
        {{ errorMessage }}
      </div>

      <div class="checkout-wrapper">
        <div class="checkout-container">
          <div
            ref="checkout"
            class="checkout"
          />
        </div>
      </div>
    </section>
  </CalicoOnboarding>
</template>

<script>
import CalicoOnboarding from "@/components/template/onboarding/index.vue"
import services from "@/services"
import { initStripeCheckout } from "@/utils/stripe"
import { RoutesEnum } from "@/enums"

export default {
  name: 'PaymentScreen',
  components: {
    CalicoOnboarding,
  },
  data() {
    return {
      loading: false,
      errorMessage: '',
      embeddedCheckout: null,
      initializing: false,
    }
  },
  async mounted() {
    await this.$nextTick()
    await this.initCheckout()
  },
  async beforeUnmount() {
    try {
      if (this.embeddedCheckout?.destroy) {
        this.embeddedCheckout.destroy()
      }
    } catch (err) {
      console.error('[PaymentScreen] Failed to destroy embedded checkout', err)
    } finally {
      this.embeddedCheckout = null
    }
  },
  methods: {
    async initCheckout() {
      if (this.initializing) return

      this.initializing = true
      this.loading = true
      this.errorMessage = ''

      try {
        const { clientSecret, alreadySubscribed } = await services.billing.createCheckoutSession()

        if (alreadySubscribed) {
          this.$router.push(RoutesEnum.BUSINESS_DASHBOARD)
          return
        }

        if (!clientSecret) {
          throw new Error('Failed to initialize checkout')
        }

        this.loading = false
        await this.$nextTick()

        this.embeddedCheckout = await initStripeCheckout(clientSecret, this.$refs.checkout)

      } catch (err) {
        console.error('[PaymentScreen] initCheckout failed', err)
        this.errorMessage = err?.message || 'Something went wrong. Please try again.'
      } finally {
        this.loading = false
        this.initializing = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.payment {
  @include stack-space($space-large);
  @include inset-space($space-large);
  align-items: flex-start;

  .checkout-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .checkout-container {
    width: 100%;
    max-width: 520px;
  }

  .checkout {
    min-height: 640px;
  }

  .error {
    color: $color-semantics-error;
  }
}
</style>